import pageTypes from 'Constants/dynamic-page-types';

export default {
    [pageTypes.COMPARE_SHAREHOLDERS]: 1,
    [pageTypes.REGISTERED_OVERVIEW]: 2
};
